var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGavelFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_1622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9802 20.0816V22.0816H2.98016V20.0816H14.9802ZM15.5662 0.767578L23.3442 8.54558L21.9302 9.96158L20.8702 9.60758L18.3932 12.0816L24.0502 17.7386L22.6362 19.1526L16.9802 13.4956L14.5762 15.8996L14.8592 17.0316L13.4442 18.4456L5.66616 10.6676L7.08116 9.25358L8.21116 9.53558L14.5052 3.24258L14.1522 2.18258L15.5662 0.767578Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_1622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current",
    transform: "translate(0.980164 0.0820312)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavelFilled);
export default __webpack_public_path__ + "static/media/gavel_filled.68d39743.svg";
export { ForwardRef as ReactComponent };